import { AppThunk } from 'store';
import {
  addFeedback,
  editOneFeedback,
  removeFeedback,
  getOneFeedback,
  failFetchFeedbacks,
  requestFetchFeedbacks,
  responseFetchFeedbacks,
} from 'store/feedbacks/feedbacksSlice';
import { IFeedback } from 'modules/Candidates/typings';
import feedbackService from 'services/feedbacks.service';
import { removeCandidateFeedback } from 'store/candidates/candidatesSlice';
import { setSnackbar } from 'store/snackbar/snackbarSlice';

export const addNewFeedback = (
  feedback: IFeedback,
  callback: () => void,
): AppThunk => async (dispatch) => {
  try {
    dispatch(requestFetchFeedbacks());
    const res = await feedbackService.addNew(feedback);
    dispatch(addFeedback(res));
    callback();
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'success',
        snackbarMessage: 'Feedback was added',
      }),
    );
  } catch (err) {
    dispatch(
      failFetchFeedbacks({
        message: err.message,
        status: err.status,
        error: true,
      }),
    );
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'error',
        snackbarMessage: 'Feedback could not be added',
      }),
    );
  } finally {
    dispatch(responseFetchFeedbacks());
  }
};

export const deleteFeedback = (id: string): AppThunk => async (
  dispatch,
) => {
  try {
    dispatch(requestFetchFeedbacks());
    await feedbackService.deleteOne(id);
    dispatch(removeCandidateFeedback(id));
    dispatch(removeFeedback(id));
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'success',
        snackbarMessage: 'Feedback was deleted',
      }),
    );
  } catch (err) {
    dispatch(
      failFetchFeedbacks({
        message: err.message,
        status: err.status,
        error: true,
      }),
    );
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'error',
        snackbarMessage: 'Feedback could not be deleted',
      }),
    );
  } finally {
    dispatch(responseFetchFeedbacks());
  }
};

export const getFeedback = (id: string): AppThunk => async (
  dispatch,
) => {
  try {
    dispatch(requestFetchFeedbacks());
    const res = await feedbackService.getById(id);
    dispatch(getOneFeedback(res));
  } catch (err) {
    dispatch(
      failFetchFeedbacks({
        message: err.message,
        status: err.status,
        error: true,
      }),
    );
  } finally {
    dispatch(responseFetchFeedbacks());
  }
};

export const editFeedback = (
  id: string,
  feedback: IFeedback,
): AppThunk => async (dispatch) => {
  try {
    dispatch(requestFetchFeedbacks());
    const res = await feedbackService.editOne(id, feedback);
    dispatch(editOneFeedback(res));
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'success',
        snackbarMessage: 'Feedback was edited',
      }),
    );
  } catch (err) {
    dispatch(
      failFetchFeedbacks({
        message: err.message,
        status: err.status,
        error: true,
      }),
    );
    dispatch(
      setSnackbar({
        snackbarOpen: true,
        snackbarType: 'error',
        snackbarMessage: 'Feedback could not be edited',
      }),
    );
  } finally {
    dispatch(responseFetchFeedbacks());
  }
};
